import React, { useEffect } from "react";
import { createPortal } from "react-dom";

export default function BottomSheet({ open, title, onClose, children }) {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (typeof document === "undefined") return null;

  return createPortal(
    <div className={`ea-ov ${open ? "open" : ""}`} aria-hidden={!open}>
      <div className="ea-ov__bg" onClick={onClose} />
      <div className="ea-sheet" role="dialog" aria-modal="true">
        <div className="ea-sheet__grip" />
        {title ? <div className="ea-sheet__title">{title}</div> : null}
        {children}
      </div>
    </div>,
    document.body
  );
}
